import { add, listen, qs, remove, toggle } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';
import PredictiveSearch from '@/lib/predictive-search';

const classes = {
  active: 'active',
  visible: 'visible',
};

export default function (node) {
  const overlay = qs('[data-overlay]', node);
  const input = qs('[data-input]', node);
  const clear = qs('[data-clear]', node);
  const resultsContainer = qs('[data-results]', node);
  const predictiveSearch = PredictiveSearch(resultsContainer);
  const closeButton = qs('[data-close-icon]', node);

  const events = [
    listen([overlay, closeButton], 'click', close),
    listen(clear, 'click', reset),
    listen(input, 'input', handleInput),
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) close();
    }),
  ];

  const trap = createFocusTrap(node, { allowOutsideClick: true });

  function handleInput(e) {
    if (e.target.value === '') reset();
    toggle(clear, classes.visible, e.target.value !== '');
    toggle(input.parentNode, classes.active, e.target.value !== '');

    predictiveSearch.getSearchResults(e.target.value);
  }

  // Clear contents of the search input and hide results container
  function reset(e) {
    e && e.preventDefault();
    input.value = '';
    remove(clear, classes.visible);
    remove(input.parentNode, classes.active);
    resultsContainer.innerHTML = '';

    input.focus();
  }

  function open() {
    add(node, classes.active);
    trap.activate();

    setTimeout(() => {
      input.focus();
      disableBodyScroll(node, { reserveScrollBarGap: true });
      add(node, classes.visible);
    }, 50);
  }

  function close() {
    remove(node, classes.visible);
    trap.deactivate();
    setTimeout(() => {
      remove(node, classes.active);
      enableBodyScroll(node);
    }, 350);
  }

  function destroy() {
    close();

    events.forEach(unsubscribe => unsubscribe());
  }

  return { open, close, destroy };
}
